import { render, staticRenderFns } from "./HomeGroupCard.vue?vue&type=template&id=754b1ee4&scoped=true&"
import script from "./HomeGroupCard.vue?vue&type=script&lang=js&"
export * from "./HomeGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeGroupCard.vue?vue&type=style&index=0&id=754b1ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b1ee4",
  null
  
)

export default component.exports